import { useForm } from 'react-hook-form';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

interface OwnerFormProps {
  onSubmit: (data: { name: string; email?: string; organization?: string }) => Promise<void>;
  onCancel: () => void;
  defaultValues?: {
    name: string;
    email: string;
    organization: string;
  };
}

export function OwnerForm({ onSubmit, onCancel, defaultValues }: OwnerFormProps) {
  const { register, handleSubmit, formState: { errors, isSubmitting } } = useForm({
    defaultValues: defaultValues || {
      name: '',
      email: '',
      organization: ''
    }
  });

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
      {errors.error && (
        <div className="p-3 text-sm text-red-500 bg-red-50 dark:bg-red-900/20 rounded-md">
          {errors.error.message}
        </div>
      )}

      <div className="space-y-2">
        <Label htmlFor="name">Name <span className="text-red-500">*</span></Label>
        <Input
          id="name"
          {...register('name', { required: 'Name is required' })}
          placeholder="Enter name"
          className={errors.name ? 'border-red-500' : ''}
        />
        {errors.name && (
          <p className="text-sm text-red-500">{errors.name.message}</p>
        )}
      </div>

      <div className="space-y-2">
        <Label htmlFor="email">Email</Label>
        <Input
          id="email"
          type="email"
          {...register('email')}
          placeholder="Enter email (optional)"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="organization">Organization</Label>
        <Input
          id="organization"
          {...register('organization')}
          placeholder="Enter organization (optional)"
        />
      </div>

      <div className="flex justify-end gap-2">
        <Button type="button" variant="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button type="submit" disabled={isSubmitting}>
          {defaultValues ? 'Update' : 'Create'} {isSubmitting ? '...' : 'Owner'}
        </Button>
      </div>
    </form>
  );
}